module.exports = __webpack_public_path__ + "fonts/Muli-SemiBold.a7cd7054.eot";